export default {
  raised: '0px 2px 4px rgba(0, 0, 0, 0.02)',
  // TODO
  floating: '0px 5px 10px rgba(0, 0, 0, 0.04)',
  overlay: '0px 15px 20px rgba(0, 0, 0, 0.1)',
  // TODO
  dialog: '0px 20px 40px rgba(0, 0, 0, 0.2)' // TODO

};